import VideoInterface from '../VideoInterface'

export default class WakUpMidnight extends VideoInterface {

}
